import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Box, TextField,Typography, Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';

import { createPaymentMethod } from '../../../walletApi'
import { isAuthenticated } from "../../../../auth";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
      width: theme.spacing(50),
      height: theme.spacing(50),
    },
  },
  cardSpace:{marginTop: "250px", margin: "auto"}
}));

export default function PaymentMethod({dataHandler}) {
  const classes = useStyles();
  const { token } = isAuthenticated();
  const [formData, setFormData] = useState({})


  const handleSubmit = (e) =>{
    e.preventDefault()

    const datas ={
      type:'card',
      card_number: formData.card_number,
      exp_month: parseInt(formData.exp_month),
      exp_year: parseInt(formData.exp_year),
      cvc: formData.cvc,
      addressl1: formData.addressl1,
      addressl2: formData.addressl2,
      city: formData.city, 
      state: formData.state,
      postal_code: formData.postal_code,
      country: formData.country,
      name: formData.name,
      email: formData.email,
      phone: formData.phone
  }
  createPaymentMethod(datas, token).then((data =[]) =>{
      if (data && data.error) {
        console.log(data.error) 
     } else {
       dataHandler(data.data)
     }
    }) 
   
   
  }

  return (
    <Container>
        <div className={classes.root}>
           <Box className={classes.cardSpace}>
                <Paper elevation={3}>
                  <Typography> Enter Amount</Typography>
                  <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <TextField 
                      id="outlined-basic" 
                      label="Card number" 
                      variant="outlined"
                      onChange={(e) => 
                        setFormData({...formData, card_number:e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="Expiration month" 
                      variant="outlined"
                      value={formData.exp_month}
                      onChange={(e) => 
                        setFormData({...formData, exp_month: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="Expiration year" 
                      variant="outlined"
                      value={formData.exp_year}
                      onChange={(e) => 
                        setFormData({...formData, exp_year: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="CVC" 
                      variant="outlined"
                      value={formData.cvc}
                      onChange={(e) => 
                        setFormData({...formData, cvc: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="line1" 
                      variant="outlined"
                      value={formData.addressl1}
                      onChange={(e) => 
                        setFormData({...formData, addressl1: e.target.value
                      })}  
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="line2" 
                      variant="outlined"
                      value={formData.addressl2}
                      onChange={(e) => 
                        setFormData({...formData, addressl2: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="City" 
                      variant="outlined"
                      value={formData.city}
                      onChange={(e) => 
                        setFormData({...formData, city: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="State" 
                      variant="outlined"
                      value={formData.state}
                      onChange={(e) => 
                        setFormData({...formData, state: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="postal code" 
                      variant="outlined"
                      value={formData.postal_code}
                      onChange={(e) => 
                        setFormData({...formData, postal_code: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="country" 
                      variant="outlined"
                      value={formData.country}
                      onChange={(e) => 
                        setFormData({...formData, country: e.target.value
                      })} 
                    />
                     <TextField 
                      id="outlined-basic" 
                      label="name" 
                      variant="outlined"
                      value={formData.name}
                      onChange={(e) => 
                        setFormData({...formData, name: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="email" 
                      variant="outlined"
                      value={formData.email}
                      onChange={(e) => 
                        setFormData({...formData, email: e.target.value
                      })} 
                    />
                    <TextField 
                      id="outlined-basic" 
                      label="phone" 
                      variant="outlined"
                      value={formData.phone}
                      onChange={(e) => 
                        setFormData({...formData, phone: e.target.value
                      })} 
                    />
                    <br/>            
                      <Button
                        type='submit' 
                        variant="contained" 
                        color="secondary"
                      >
                        Next
                      </Button>
                  </form>
                </Paper>
           </Box>
        </div>
      </Container>
  );
}
